import { render, staticRenderFns } from "./editPayment.vue?vue&type=template&id=70614ae4&scoped=true"
import script from "./editPayment.vue?vue&type=script&lang=js"
export * from "./editPayment.vue?vue&type=script&lang=js"
import style0 from "./editPayment.vue?vue&type=style&index=0&id=70614ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70614ae4",
  null
  
)

export default component.exports